const initRaffleOcrActivity = {
  raffleOcrActivities: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterCityPage: "",
};

export const raffleOcrActivityReducer = (state = initRaffleOcrActivity, action: any) => {
    if (action.type === "SET_RAFFLE_OCR_ACTIVITY") {
      return {
        ...state,
        raffleOcrActivities: action.value,
      };
    }
    if (action.type === "SET_RAFFLE_OCR_ACTIVITY_CURRENT_PAGE") {
      return {
        ...state,
        currentPage: action.currentPage,
      };
    }
    if (action.type === "SET_RAFFLE_OCR_ACTIVITY_PAGE") {
      return {
        ...state,
        totalPage: action.totalPage,
        limitPage: action.limitPage,
        lengthPage: action.lengthPage,
      };
    }
    if (action.type === "SET_SEARCH_RAFFLE_OCR_ACTIVITY") {
      return {
        ...state,
        searchValue: action.searchValue,
      };
    }
    if (action.type === "SET_RAFFLE_OCR_ACTIVITY_FILTER_PAGE") {
      return {
        ...state,
        filterCityPage: action.filterCityPage,
      };
    }
    return state;
  };
  